import { render } from "./LinkInline.vue?vue&type=template&id=6bc11272&scoped=true"
import script from "./LinkInline.vue?vue&type=script&lang=js"
export * from "./LinkInline.vue?vue&type=script&lang=js"

import "./LinkInline.vue?vue&type=style&index=0&id=6bc11272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc11272"]])

export default __exports__